module.exports = __webpack_public_path__ + "img/card-with-logo.c8fcbcc4.webp";